import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-declare-rejection-reason',
  templateUrl: './modal-declare-rejection-reason.component.html',
  styleUrls: ['./modal-declare-rejection-reason.component.css']
})
export class ModalDeclareRejectionReasonComponent {

}
